import React from 'react';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { Colors } from '@lib/enums/colors';
import styles from './IconSurface.module.scss';

export type IconSurfaceShape = 'circle' | 'rounded' | 'square';
export type IconSurfaceSize = 'sm' | 'md' | 'lg';

export type IconSurfaceProps = {
  icon: string;
  color?: Colors;
  shape?: IconSurfaceShape;
  size?: IconSurfaceSize;
  className?: string;
  symbolsOutlined?: boolean;
};

const iconFontSizeByContainer: Record<IconSurfaceSize, string> = {
  sm: 'md-16',
  md: 'md-20',
  lg: 'md-24',
};

export default function IconSurface(props: IconSurfaceProps) {
  const {
    icon,
    color = Colors.Blue,
    shape = 'circle',
    size = 'lg',
    className,
    symbolsOutlined,
  } = props;

  const wrapperClassName = classNames(
    styles.surface,
    styles[shape],
    styles[size],
    styles[color],
    className,
  );

  return (
    <div>
      <div className={wrapperClassName}>
        <MaterialIcon
          icon={icon}
          size={iconFontSizeByContainer[size]}
          symbolsOutlined={symbolsOutlined}
        />
      </div>
    </div>
  );
}
